import module from 'cliente/module.js'

export class ClienteInformacionBancosDocumentoPdfService {
  constructor ($http) {
    this.$http = $http
  }

  get (idCliente, idCuenta, idDocumento) {
    return this.$http.get('/api/clientes/cliente/informacion/bancos/documento/pdf', {
      params: {
        idCliente: idCliente,
        idCuenta: idCuenta,
        idDocumento: idDocumento,
      },
      download: true,
    })
  }

  delete (idCliente, idCuenta) {
    return this.$http.delete('/api/clientes/cliente/informacion/bancos/documento/pdf', {
      params: {
        idCliente: idCliente,
        idCuenta: idCuenta,
      },
      schema,
    })
  }
}

module.service('ClienteInformacionBancosDocumentoPdf', ClienteInformacionBancosDocumentoPdfService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Bancos/Documento/Pdf.js